if(document.getElementById('feedbackModal')) {
	window.feedbackModal = new Modal(document.getElementById('feedbackModal'), {
		keyboard: false
	});

	window.closeModalNewsLetter = function(data, status, xhr, form) {
		clearForm(data,form);
		window.feedbackModal.hide();
	}

}
